import React from "react";

// components
import GraficoVentas from "components/Cards/CardLineChart.js";
import GraficoPedidos from "components/Cards/CardBarChart.js";
import EstadisticaVisitantes from "components/Cards/CardPageVisits.js";
import EstadisticaTraficoSocial from "components/Cards/CardSocialTraffic.js";

export default function Dashboard() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <GraficoVentas />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <GraficoPedidos />
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <EstadisticaVisitantes />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <EstadisticaTraficoSocial />
        </div>
      </div>
    </>
  );
}
